
import { Component, Vue, Watch, Prop, Ref } from 'vue-property-decorator';
import { GruppoDistinte, Distinta, RigaDistinta, RigaDistintaQtaTaglia, ComunicazioneVariazioneRigaDistinta, StatoVariazioneRigaDistinta, ItemDatiLookup, StatoSyncRigaDistinta } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import { VariazioneDaComunicare, TipoVariazione, RigaDistintaPerComunicazioneVariazione, VariazioneDaComunicareQtaTaglia } from '@/models';
import { DialogNewVariazione, RigaDistintaListaVariazioni } from '@/components';
import VariazioniMassive from './VariazioniMassive.vue';
import TabellaValori from './TabellaValori.vue';

@Component({
  components: {
    TabellaValori,
    RigaDistintaListaVariazioni,
    DialogNewVariazione,
    VariazioniMassive
  }
})
export default class RigheDistintaComunicazioneConsumi extends Vue {
  @Prop() private idDistinta!: string;
  private variazioniValide!: boolean;
  private tipoVariazione = TipoVariazione;
  private listaVariazioniDaComunicare: VariazioneDaComunicare[] = [];
  @Ref() private dialogNuovaVariazione! : DialogNewVariazione;

  get loading() { return store.state.loading }

  get unitaDiMisura(): ItemDatiLookup[] { return store.state.datiLookup!.umRigheDistinte; }

  get containsVariazioni(): boolean {
    return this.listaVariazioniDaComunicare.some(
      (comunicazione: VariazioneDaComunicare) =>
        this.isModified(comunicazione) ||
        this.isDeleted(comunicazione) ||
        this.isNuova(comunicazione)
    );
  }

  @Watch('listaVariazioniDaComunicare', { deep: true, immediate: true })
  onVariazioniValide(): void {
    this.variazioniValide = this.listaVariazioniDaComunicare.every(
      (variazione: VariazioneDaComunicare) => variazione.valida
    );
    this.$forceUpdate();
  }

  async confermaVariazione() {
    let variazioniDaComunicare: VariazioneDaComunicare[] = [];
    this.listaVariazioniDaComunicare.forEach((comunicazione: VariazioneDaComunicare) => {
        if (this.isModified(comunicazione) || this.isDeleted(comunicazione) || this.isNuova(comunicazione)) {
          variazioniDaComunicare.push(comunicazione);
        }
        
        // gestione correlate per comunicazione massiva... invio correlate nuove o modificate/cancellate nel caso la master non sia nuova
        comunicazione.variazioniCorrelate.forEach((correlata: VariazioneDaComunicare) => {
          if(this.isNuova(correlata)) {
            variazioniDaComunicare.push(correlata);
          }
          else if(!this.isNuova(comunicazione) && (this.isModified(correlata) || this.isDeleted(correlata))) {
            variazioniDaComunicare.push(correlata);
          }
        });
      }
    );

    let comunicazioneVariazioneRigaDistinta: ComunicazioneVariazioneRigaDistinta[] = [];
    variazioniDaComunicare.forEach((comunicazione: VariazioneDaComunicare) => {
      let statoVariazioneRiga: StatoVariazioneRigaDistinta =StatoVariazioneRigaDistinta.RigaAggiuntaDalFornitore;
      switch (comunicazione.tipoVariazione) {
        case TipoVariazione.NUOVA:
          break;
        case TipoVariazione.MODIFICABILE:
          statoVariazioneRiga = StatoVariazioneRigaDistinta.RigaModificataDalFornitore;
          break;
        case TipoVariazione.ELIMINATA:
          statoVariazioneRiga = StatoVariazioneRigaDistinta.RigaEliminataDalFornitore;
          break;
        default:
          console.log('Tipo variazione non riconosciuto');
          break;
      }

      let variazione: ComunicazioneVariazioneRigaDistinta = {
        idFornitore: store.state.currentUsr.idFornitore,
        idDistinta: comunicazione.idDistintaAppartenenza,
        idRigaDistinta: comunicazione.rigaDistinta.id,
        idUtente: store.state.currentUsr.userName,
        quantitaPerTaglia: [],
        statoVariazione: statoVariazioneRiga
      };

      if (variazione.statoVariazione == StatoVariazioneRigaDistinta.RigaAggiuntaDalFornitore) {
          variazione.nuovaRigaDistinta = comunicazione.rigaDistinta;
      }

      comunicazione.variazioneRigaDistintaQtaTaglia.forEach(qtaVariazione => {
        variazione.quantitaPerTaglia.push(qtaVariazione.qtaModificata);
      });

      comunicazioneVariazioneRigaDistinta.push(variazione);
    });

    let risultato: boolean = await store.dispatch(
      StoreActions.ComunicaVariazioniRigheDistinteDPC,
      comunicazioneVariazioneRigaDistinta
    );
  }

  private onVariazioneCreata(variazione: VariazioneDaComunicare) {          
      variazione.rigaDistinta.indiceRiga =
        Math.max(
          ...this.listaVariazioniDaComunicare.map(
            (v: VariazioneDaComunicare) => v.rigaDistinta.indiceRiga
          )
        ) + 1;
      this.listaVariazioniDaComunicare.push(variazione);          
  }
  
  private openDialog(){ 
    //non si può prendere come template la quantitaPerTaglia della prima riga perchè spesso ha più taglie inutili
    //quindi per ora prendo l'ultima
    if(this.listaVariazioniDaComunicare.length>0)
    {
        this.dialogNuovaVariazione.updateQtaPerTagliaTemplate(this.listaVariazioniDaComunicare[this.listaVariazioniDaComunicare.length-1]?.variazioneRigaDistintaQtaTaglia || []);
        this.dialogNuovaVariazione.open(); 
    }
  }

  undoVariazione(variazione: VariazioneDaComunicare) {
    // switch (variazione.tipoVariazione) {
    //   case TipoVariazione.ELIMINATA:
    //     variazione.tipoVariazione = TipoVariazione.MODIFICABILE;
    //     break;
    //   case TipoVariazione.MODIFICABILE:
    //     variazione.tipoVariazione = TipoVariazione.MODIFICABILE;
    //     break;
    // }

    variazione.tipoVariazione = TipoVariazione.MODIFICABILE;

    // gestione correlate per comunicazione massiva
    variazione.variazioniCorrelate.forEach((correlata: VariazioneDaComunicare) => {
      correlata.tipoVariazione = TipoVariazione.MODIFICABILE;
    });
  }

  eliminaVariazione(variazione: VariazioneDaComunicare) {
    switch (variazione.tipoVariazione) {
      case TipoVariazione.NUOVA:
        this.listaVariazioniDaComunicare = this.listaVariazioniDaComunicare.filter(
          (v: VariazioneDaComunicare) => v != variazione
        );
        break;
      default:
        variazione.tipoVariazione = TipoVariazione.ELIMINATA;
        break;
    }
  }

  isModified(variazione: VariazioneDaComunicare): boolean {
    return variazione.variazioneRigaDistintaQtaTaglia.some(
      (variazione: VariazioneDaComunicareQtaTaglia) =>
        variazione.qta != variazione.qtaModificata
    );
  }

  contieneModificheCorrelate(v: VariazioneDaComunicare): boolean {
    return v.variazioniCorrelate.some((correlata: VariazioneDaComunicare) => {
      return correlata.tipoVariazione == TipoVariazione.NUOVA
        || (v.tipoVariazione != TipoVariazione.NUOVA && this.isModified(correlata))
        || (v.tipoVariazione != TipoVariazione.NUOVA && this.isDeleted(correlata));
    });
  }

  isDeleted(variazione: VariazioneDaComunicare): boolean {
    return variazione.tipoVariazione == TipoVariazione.ELIMINATA;
  }

  isNuova(variazione: VariazioneDaComunicare): boolean {
    return variazione.tipoVariazione == TipoVariazione.NUOVA;
  }

  @Watch('$store.state.distintaCorrente', { immediate: true })
  onCambioDistinta(distinta: Distinta): void {
    this.listaVariazioniDaComunicare = [];
    const maxIndice = Math.max(...distinta.righeDistintaDPC.map((r: RigaDistinta) => r.indiceRiga));
    distinta.righeDistintaDPC.forEach((riga: RigaDistinta) => {
      // let addToList = false;
      // if (riga.statoSincronizzazioneVariazione != StatoSyncRigaDistinta.STATO_SINCRONIZZAZIONE_VARIAZIONE_COMUNICATA_AD_AS400_MANUALMENTE) 
      //   addToList = true;
      // else{
      //   if(!riga.variazioniComunicate) return;
      //   let max = Math.max(...riga.variazioniComunicate.map(va => va.indice));
      //   let lastVariation = riga.variazioniComunicate.find(v => v.indice == max);
      //   if(!lastVariation) return;           
      //   addToList = lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaAggiuntaDaBC &&
      //     lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaEliminataDaBC          
      // }
      //if(addToList) {
      if(this.isRigaModificabile(riga)) {
          let listaVariazioneRigaDistintaQtaTaglia: VariazioneDaComunicareQtaTaglia[] = [];

          if (riga.quantitaPerTaglia) {
            riga.quantitaPerTaglia.forEach(
              (rigaDistintaQtaTaglia: RigaDistintaQtaTaglia) => {
                let variazioneRigaDistintaQtaTaglia: VariazioneDaComunicareQtaTaglia = {
                  indice: rigaDistintaQtaTaglia.indice,
                  qta: rigaDistintaQtaTaglia.qta,
                  desc: rigaDistintaQtaTaglia.desc,
                  qtaModificata: rigaDistintaQtaTaglia.qta
                };
                listaVariazioneRigaDistintaQtaTaglia.push(
                  variazioneRigaDistintaQtaTaglia
                );
              }
            );
          }

          let variazione: VariazioneDaComunicare = {
            rigaDistinta: riga,
            variazioneRigaDistintaQtaTaglia: listaVariazioneRigaDistintaQtaTaglia,
            tipoVariazione: TipoVariazione.MODIFICABILE,            
            valida: true,
            // Props per gestione correlate
            idDistintaAppartenenza: distinta.id,
            mostraCorrelate: false,
            eliminataDaAs400: riga.eliminataDaAs400,
            idModelloRiferimento: distinta.idModello,
            variazioniCorrelate: this.caricaCorrelate(distinta.id, distinta.idModello, 
                                    riga.innerRigaDistinta.idComponenteBga,
                                    riga.innerRigaDistinta.posizRiga)
          };
          
          variazione.rigaDistinta.indiceRiga = parseInt(riga.innerRigaDistinta.posizRiga) || 0;
          this.caricaCorrelate
          this.listaVariazioniDaComunicare.push(variazione);
      }      
    });   
    this.listaVariazioniDaComunicare.sort((a, b) => (a.rigaDistinta.indiceRiga < b.rigaDistinta.indiceRiga ? -1 : 1)); 
  }

  isRigaModificabile(riga: RigaDistinta): boolean {
    
    if (riga.statoSincronizzazioneVariazione != StatoSyncRigaDistinta.STATO_SINCRONIZZAZIONE_VARIAZIONE_COMUNICATA_AD_AS400_MANUALMENTE)
      return true;

    if(!riga.variazioniComunicate)
      return false;

    let max = Math.max(...riga.variazioniComunicate.map(va => va.indice));
    let lastVariation = riga.variazioniComunicate.find(v => v.indice == max);
    if(!lastVariation)
      return false;

    return lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaAggiuntaDaBC &&
      lastVariation.statoValidazione != StatoVariazioneRigaDistinta.RigaEliminataDaBC;
  }

  caricaCorrelate(idDistinta: string, idModelloRiferimento: string, idComponente: string, posizRiga: string): VariazioneDaComunicare[] {
    let correlate: VariazioneDaComunicare[] = [];
    
    let distinteCorrelate = store.state.uiConsumi.listaDistinteCorrelate;
    
    distinteCorrelate.forEach((distinta: Distinta) => {
      let rigaCorrelata = distinta.righeDistintaDPC.find((riga: RigaDistinta) => 
        riga.innerRigaDistinta.idComponenteBga == idComponente && 
        riga.innerRigaDistinta.posizRiga == posizRiga);
      if(distinta.id != idDistinta && rigaCorrelata && this.isRigaModificabile(rigaCorrelata)) {
        // creo una variazione per la riga relativa allo stesso componente di quella di riferimento,
        // ma di un'altra distinta sempre legata al modello a cui è legata la variazione di riferimento
        var vCorrelata: VariazioneDaComunicare = {
          rigaDistinta: rigaCorrelata,
          variazioneRigaDistintaQtaTaglia: [],
          tipoVariazione: TipoVariazione.MODIFICABILE,            
          valida: true,
          eliminataDaAs400: rigaCorrelata.eliminataDaAs400,
          idDistintaAppartenenza: distinta.id,
          idModelloRiferimento: distinta.idModello,
          variazioniCorrelate: []
        };
        
        if (rigaCorrelata.quantitaPerTaglia) {
          rigaCorrelata.quantitaPerTaglia.forEach((qtaTaglia: RigaDistintaQtaTaglia) => {
            let variazioneRigaDistintaQtaTaglia: VariazioneDaComunicareQtaTaglia = {
              indice: qtaTaglia.indice,
              desc: qtaTaglia.desc,
              qta: qtaTaglia.qta,
              qtaModificata: qtaTaglia.qta
            };              
            vCorrelata.variazioneRigaDistintaQtaTaglia.push(variazioneRigaDistintaQtaTaglia);
          });
        }

        correlate.push(vCorrelata)
      }
    });

    return correlate;
  }
}
